import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setInsuredOptions as setInsuredOptionsAction } from '../store/options.actions'
import { RelationshipsAndGuarantorsConstants } from '../../relationshipsAndGuarantors/store/relationshipsAndGuarantors.constants'
import { getRelationshipsAndGuarantors } from '../../relationshipsAndGuarantors/selectors/getRelationshipsAndGuarantors.selector'
import { IRelationshipsAndGuarantorsState } from '../../relationshipsAndGuarantors/store/relationshipsAndGuarantors.types'
import { patientInsuredOption } from '../store/options.reducers'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IInsuredOptions } from '../store/options.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setInsuredOptions() {
  const relationshipsAndGuarantorState: IRelationshipsAndGuarantorsState = yield select(getRelationshipsAndGuarantors)
  const { relationshipsAndGuarantorsList } = relationshipsAndGuarantorState
  try {
    const insuredOptions: IInsuredOptions = [patientInsuredOption]
    relationshipsAndGuarantorsList.forEach((rag) => {
      const lastName = rag.lastName ? ` ${rag.lastName}` : ''
      const relation = rag.relationship && rag.relationship?.name ? ` (${rag.relationship?.name})` : ''
      if (rag.firstName || lastName || relation) {
        insuredOptions.push({
          id: +rag.key,
          ptid: rag.ptid,
          name: `${rag.firstName}${lastName}${relation}`,
        })
      }
    })
    yield put(setInsuredOptionsAction(insuredOptions))
  } catch (e) {
    yield put(throwPcrException(`setInsuredOptions() error: ${e}`))
  }
}
export function* setInsuredOptionsSaga() {
  yield takeLatest(
    [
      RelationshipsAndGuarantorsConstants.SET_RELATIONSHIPS_AND_GUARANTORS_STATE,
      RelationshipsAndGuarantorsConstants.SET_RELATIONSHIPS_AND_GUARANTORS_LIST,
      ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS,
    ],
    performWithMutexHOG,
    setInsuredOptions
  )
}
